<i
  class="fa fa-info-circle def tmo-tooltip"
  #toolTip
  appendTo="{{ appendTo }}"
  pTooltip="{{ text }}"
  tabindex="{{ tabIndex }}"
  tooltipEvent="{{ event }}"
  tooltipPosition="{{ position }}"
  title="{{ text }}"
  [attr.aria-label]="ariaLabel"
>
</i>
